import api from './api';

export interface TwoFactorSetupResponse {
  secret: string;
  qrCode: string;
  manualEntryKey: string;
}

export interface TwoFactorStatusResponse {
  enabled: boolean;
}

export const twoFactorService = {
  // Configurar 2FA - obtener QR code y secret
  async setup(): Promise<TwoFactorSetupResponse> {
    const response = await api.post('/auth/2fa/setup');
    return response.data.data;
  },

  // Verificar código y habilitar 2FA
  async verify(token: string): Promise<void> {
    await api.post('/auth/2fa/verify', { token });
  },

  // Deshabilitar 2FA
  async disable(token: string): Promise<void> {
    await api.post('/auth/2fa/disable', { token });
  },

  // Obtener estado de 2FA
  async getStatus(): Promise<TwoFactorStatusResponse> {
    const response = await api.get('/auth/2fa/status');
    return response.data.data;
  },
};